// 菜单管理模块
import request from '../request.js'

//根据菜单id, 获取按钮信息；根据角色id,菜单id,获取已选中的按钮信息-李开明
export const getBtnsByMenuId = function (data) {
    return request({
        url: 'sysBtn/getBtnsByMenuId',
        method: 'post',
        data
    })
}
//根据菜单id, 获取按钮信息；根据角色id,菜单id,获取已选中的按钮信息-李开明
export const getBtnsByRoleIdMenuId = function (data) {
    return request({
        url: 'sysBtn/getBtnsByRoleIdMenuId',
        method: 'post',
        data
    })
}
//新增/修改-李开明
export const saveOrUpdate = function (data) {
    return request({
        url: 'sysBtn/saveOrUpdate',
        method: 'post',
        data
    })
}
//根据id获取对象信息-李开明
export const getInfoById = function (data) {
    return request({
        url: 'sysBtn/getInfoById',
        method: 'post',
        data
    })
}
//根据id删除按钮-李开明
export const deleteById = function (data) {
    return request({
        url: 'sysBtn/deleteById',
        method: 'post',
        data
    })
}
